import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { MAX_PRODUCTS_TO_COMPARE } from "@insite/client-framework/Store/Components/CompareProductsDrawer/CompareProductsDrawerSelectors";
import {
    chain,
    CheckIncludeAttributeTypesParameter,
    SetProductIdsParameter,
} from "@insite/client-framework/Store/Components/CompareProductsDrawer/Handlers/LoadProductsToCompare";

replaceInChain(chain, SetProductIdsParameter, props => {
    props.apiParameter = {
        productIds: props.parameter.productIds,
        pageSize: MAX_PRODUCTS_TO_COMPARE,
        expand: ["images", "properties", "badges"],
    };
});

replaceInChain(chain, CheckIncludeAttributeTypesParameter, props => {
    if (props.parameter.includeAttributeTypes) {
        props.apiParameter.expand?.push("attributes", "properties");
        props.apiParameter.includeAttributes = ["includeOnProduct"];
    }
});
